module.exports = "<sa-header></sa-header>\r\n\r\n<spinner name=\"spinner\"></spinner>\r\n\r\n<sa-navigation></sa-navigation>\r\n\r\n<div id=\"main\" role=\"main\">\r\n  <!-- <sa-layout-switcher></sa-layout-switcher> -->\r\n\r\n  <!--<sa-ribbon></sa-ribbon>-->\r\n  <router-outlet></router-outlet>\r\n</div>\r\n\r\n<sa-footer></sa-footer>\r\n\r\n<!-- <sa-shortcut></sa-shortcut> -->\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/layout/app-layouts/main-layout.component.html
// module id = ./src/app/shared/layout/app-layouts/main-layout.component.html
// module chunks = main